module.exports = __webpack_public_path__ + "aca65126af0ba9f4e417dbf2d5efee00.png";


/*****************
 ** WEBPACK FOOTER
 ** ./example/images/example.png
 ** module id = 287
 ** module chunks = 0
 **/